// Utility module for safe Platform access
// This module ensures Platform is available before using it

let _Platform = null;

export const getPlatform = () => {
    if (!_Platform) {
        try {
            const { Platform } = require('react-native');
            _Platform = Platform;
        } catch (error) {
            console.warn('Platform not available yet, using fallback');
            _Platform = {
                OS: 'unknown',
                select: (options) => options.default || null
            };
        }
    }
    return _Platform;
};

export const isWeb = () => {
    const platform = getPlatform();
    return platform.OS === 'web';
};

export const isIOS = () => {
    const platform = getPlatform();
    return platform.OS === 'ios';
};

export const isAndroid = () => {
    const platform = getPlatform();
    return platform.OS === 'android';
};

// Safe platform select function
export const platformSelect = (options) => {
    const platform = getPlatform();
    return platform.select(options);
};